import * as React from 'react'
import { Link } from 'react-router-dom'
import UIMessages from '../../../../../utils/ui-messages'
import HorizontalSelectorItemCustom from './HorizontalSelectorItemCustom'

export interface IProductStepSelectorProps {
  pathname: string
  productId: string
}

const ProductStepSelector = ({ pathname, productId }: IProductStepSelectorProps) => {
  return (
    <div className='col-12'>
      <div className='flex bb-light-grey4'>
        <HorizontalSelectorItemCustom isSelected={/\/info/.test(pathname)}>
          <Link className={'uppercase'} to={`/products/${productId}/info`}>
            {UIMessages.product.productInfo}
          </Link>
        </HorizontalSelectorItemCustom>

        <HorizontalSelectorItemCustom isSelected={/\/pricing/.test(pathname)}>
          <Link className={'uppercase'} to={`/products/${productId}/pricing`}>
            {UIMessages.product.productPricing}
          </Link>
        </HorizontalSelectorItemCustom>

        <HorizontalSelectorItemCustom isSelected={/\/integration/.test(pathname)}>
          <Link className={'uppercase'} to={`/products/${productId}/integration`}>
            {UIMessages.product.productIntegration}
          </Link>
        </HorizontalSelectorItemCustom>

        <div style={{ flex: 4 }}>&nbsp;</div>

        <div className='absolute z1 left-0 right-0 bottom-0 bb-light-grey4' />
      </div>
    </div>
  )
}

export default ProductStepSelector



// WEBPACK FOOTER //
// ./src/components/products/details/product/details/ProductStepSelector.tsx